import { Directive, ElementRef, Input, OnDestroy, inject } from '@angular/core';
import { MarkdownRendererService } from './markdown-renderer.service';

@Directive({
  selector: '[appMermaidRenderer]',
  standalone: true,
})
export class MermaidRendererDirective implements OnDestroy {
  private readonly host = inject(ElementRef<HTMLElement>);
  private readonly renderer = inject(MarkdownRendererService);
  private renderVersion = 0;

  @Input({ required: true })
  set appMermaidRenderer(markdown: string) {
    void this.render(markdown);
  }

  ngOnDestroy(): void {
    this.renderVersion++;
  }

  private async render(markdown: string): Promise<void> {
    const version = ++this.renderVersion;
    const preview = document.createElement('div');
    preview.innerHTML = this.renderer.render(markdown);
    await this.renderer.renderMermaidBlocks(preview);

    if (version !== this.renderVersion) {
      return;
    }

    this.host.nativeElement.replaceChildren(...Array.from(preview.childNodes));
  }
}
